import React, { Fragment, useEffect, useState, useMemo } from "react";
import { Input, Select, Tooltip, Modal } from "antd";
import { CheckBoxInput } from "../../Buttons";
import RangePickerComp from "../../RangePickerComp";
import { Divs } from "../../StyledComponents";
import { FiAlertCircle } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  ruleCarrying,
  validPostiConnect,
} from "../../../../helpers/ShipmentRules";
import TooltipInfo from "../../TooltipInfo";
import { numberRound } from "../../../../helpers/Utils";
import { setCodSelected } from "../../../../redux/Actions/orderAction";

const { Option } = Select;

const { confirm } = Modal;

// type = basic/bulk_action
// order_rows_total = in bulk action
export default function ShipmentAdditionalServices({
  order_rows,
  type = "basic",
  order_rows_total = 0,
  cod_details,
  order_type,
  delivery,
  variables,
  handleChangeText,
  errors,
  country_id,
  order,
  setSkipLabels,
  skip_labels,
}) {
  const [warningMessages, setWarningMessages] = useState([]);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const postiValid = useMemo(
    () =>
      validPostiConnect({
        order_type,
        delivery,
      }),
    [order_type, delivery]
  );

  useEffect(() => {
    const initialMessages = [];
    if (variables?.cod && variables?.delivery_same_day) {
      initialMessages.push(
        "[Same day delivery + COD]: Choose another payment method or courier."
      );
    }
    dispatch(setCodSelected(variables?.cod));
    if (
      postiValid &&
      (variables?.recycle || variables?.connect) &&
      +variables?.weight < 25
    ) {
      if (variables?.recycle) {
        initialMessages.push("[Recycle]: Minimum weight must be 25.");
      }
      if (variables?.connect) {
        initialMessages.push("[Connect]: Minimum weight must be 25.");
      }
    }
    setWarningMessages(initialMessages);
  }, [
    postiValid,
    order_type,
    delivery,
    variables?.cod,
    variables?.delivery_same_day,
    variables?.recycle,
    variables?.connect,
    variables?.weight,
  ]);

  const handleLoggerUpdate = async (checked, type) => {
    const { firstname, lastname } = user;
    const { id: orderId } = order;
    const isChecked = checked ? "on" : "off";
    const logData = {
      log_body: `${firstname} ${lastname}`,
      log_title: `${type} ${isChecked} ${orderId}`,
    };

    try {
      await axios.post("/api/v1/logger", logData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      {type == "basic" && (
        <Divs className="d-flex">
          <>
            <div className="mr-1" style={{ width: "50%" }}>
              <span
                className={`text-bold ${errors?.packets?.length > 0 ? "text-danger" : ""
                  }`}
              >
                Packets
              </span>
              <Input
                type="number"
                min={0}
                className={`${errors.packets ? "error_border" : ""}`}
                placeholder="Enter"
                disabled={
                  delivery == "omniva_postMachine" ||
                  delivery == "lp_express_postMachine"
                }
                name="pack"
                value={variables.pack}
                onChange={(e) => handleChangeText(e)}
              />
              {errors.packets && (
                <div className="text-danger">{errors.packets}</div>
              )}
            </div>
            <div className="ml-1" style={{ width: "50%" }}>
              <span
                className={`text-bold ${errors?.weight?.length > 0 ? "text-danger" : ""
                  }`}
              >
                Weight
              </span>
              <Input
                type="number"
                min={0}
                className={`${errors.weight ? "error_border" : ""}`}
                placeholder="Enter"
                name="weight"
                value={variables.weight}
                onChange={(e) => handleChangeText(e)}
              />
              {errors.weight && (
                <div className="text-danger">
                  {errors.weight.map((e) => (
                    <div>{e}</div>
                  ))}
                </div>
              )}
            </div>
          </>
        </Divs>
      )}
      {order_type == "lp_express" && delivery == "lp_express_postMachine" ? (
        <Divs>
          <span className="text-bold">
            {variables.pack == 1 ? "Package size" : "Package sizes"}
          </span>

          <Select
            style={{ width: "100%" }}
            placeholder="Choose"
            value={variables.lp_express_sizes}
            onChange={(e) =>
              handleChangeText({
                target: { name: "lp_express_sizes", value: e },
              })
            }
          >
            <Option value="XSmall">XSmall</Option>
            <Option value="Small">Small</Option>
            <Option value="Medium">Medium</Option>
            <Option value="Large">Large</Option>
            <Option value="XLarge">XLarge</Option>
          </Select>
        </Divs>
      ) : null}

      <table className="table table-borderless">
        <tbody>
          {ruleCarrying({ order_type, delivery }) && (
            <tr>
              <td className="align-middle px-0 pb-1" colSpan={2}>
                <CheckBoxInput
                  choised="carrying"
                  color="#f7951e"
                  text="UKD (Carrying)"
                  checked={variables.carrying}
                  onChange={(e) => {
                    handleChangeText({
                      target: { name: "carrying", value: e.target.checked },
                    });
                  }}
                />
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {!!warningMessages.length &&
        warningMessages.map((message) => (
          <div key={message} className="text-sm text-danger mb-2">
            {message}
          </div>
        ))}
    </>
  );
}

const RenderIndexOrderCOD = ({ handleChangeText, cod_details, cod_amount }) => {
  const default_cod = cod_details.default_cod;
  const waiting_payment_filtered = cod_details.waiting_payments.filter(
    (e) => e.cod
  );

  return (
    <Tooltip
      placement="top"
      title={
        <span>
          <span>
            Default COD:{" "}
            <span
              className={`cursor-pointer ${default_cod == cod_amount
                  ? "text-white font-weight-bold"
                  : "text-orange"
                }`}
              onClick={() => handleChangeText(default_cod)}
            >
              {default_cod}
            </span>
          </span>
          {waiting_payment_filtered.length > 0 && (
            <Fragment>
              {" | "}
              <span>
                Payments COD:
                {waiting_payment_filtered.map((e, idx) => (
                  <Fragment key={idx}>
                    <span
                      className={`cursor-pointer ${e.price == cod_amount
                          ? "text-white font-weight-bold"
                          : "text-orange"
                        }`}
                      onClick={() => handleChangeText(e.price || 0)}
                    >
                      {e.price || 0}
                    </span>
                    {waiting_payment_filtered.length - 1 == idx ? "" : " / "}
                  </Fragment>
                ))}
              </span>
            </Fragment>
          )}
        </span>
      }
    >
      <FiAlertCircle className="text-danger cursor-pointer" />
    </Tooltip>
  );
};

const RenderShowOrderCOD = ({ handleChangeText, cod_amount }) => {
  const {
    order: { leasing_cod, leasing_advance, total_price, waiting_payments },
  } = useSelector((state) => state.orders);
  const default_cod = leasing_cod ? leasing_advance : total_price || 0;
  const waiting_payment_filtered = waiting_payments.filter((e) => e.cod);

  if (waiting_payment_filtered.length == 0) {
    return null;
  }

  return (
    <Tooltip
      placement="top"
      title={
        <span>
          <span>
            Default COD:{" "}
            <span
              className={`cursor-pointer ${default_cod == cod_amount
                  ? "text-white font-weight-bold"
                  : "text-orange"
                }`}
              onClick={() => handleChangeText(default_cod)}
            >
              {default_cod}
            </span>
          </span>
          {waiting_payment_filtered.length > 0 && (
            <Fragment>
              {" | "}
              <span>
                Payments COD:
                {waiting_payment_filtered.map((e, idx) => (
                  <Fragment key={idx}>
                    <span
                      className={`cursor-pointer ${e.price == cod_amount
                          ? "text-white font-weight-bold"
                          : "text-orange"
                        }`}
                      onClick={() => handleChangeText(e.price || 0)}
                    >
                      {e.price || 0}
                    </span>
                    {waiting_payment_filtered.length - 1 == idx ? "" : " / "}
                  </Fragment>
                ))}
              </span>
            </Fragment>
          )}
        </span>
      }
    >
      <FiAlertCircle className="text-danger cursor-pointer" />
    </Tooltip>
  );
};

const categorizePostiService = (order_row) => {
  if (
    [
      "Senos technikos išvežimas ir naujos prijungimas",
      "Vanhojen laitteiden poistaminen ja uusien kytkeminen",
    ].includes(order_row.product_name)
  ) {
    return "recycle_connect";
  }
  if (
    ["Senos technikos išvežimas", "Vanhojen laitteiden poistaminen"].includes(
      order_row.product_name
    )
  ) {
    return "recycle";
  }
  if (
    ["Naujos technikos prijungimas", "Uusien laitteiden kytkeminen"].includes(
      order_row.product_name
    )
  ) {
    return "connect";
  }
  return null;
};
const RenderPostiServices = ({
  order_rows = [],
  variables,
  handleChangeText,
}) => {
  useEffect(() => {
    order_rows.forEach((order_row) => {
      if (!order_row?.selected) return;
      const val = categorizePostiService(order_row);
      if (val) {
        val.split("_").forEach((name) => {
          handleChangeText({
            target: { name, value: true },
          });
        });
      }
      order_row?.childs?.forEach((child) => {
        const val = categorizePostiService(child);
        if (val) {
          val.split("_").forEach((name) => {
            handleChangeText({
              target: { name, value: true },
            });
          });
        }
      });
    });
  }, [order_rows.length]);

  return (
    <>
      <tr>
        <td className="align-middle px-0  pb-1" colSpan={2}>
          <CheckBoxInput
            choised="recycle"
            color="#f7951e"
            text="Recycle"
            checked={variables.recycle}
            onChange={(e) =>
              handleChangeText({
                target: { name: "recycle", value: e.target.checked },
              })
            }
          />
        </td>
      </tr>
      <tr>
        <td className="align-middle px-0  pb-1" colSpan={2}>
          <CheckBoxInput
            choised="connect"
            color="#f7951e"
            text="Connect"
            checked={variables.connect}
            onChange={(e) =>
              handleChangeText({
                target: { name: "connect", value: e.target.checked },
              })
            }
          />
        </td>
      </tr>
    </>
  );
};
